import { MutationOptions, useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import ExternalVerificationRepository from '@/repositories/ExternalVerificationRepository';
import { AutoReverifyPayload } from '@/types/externalVerification';
import { InsuranceVerification } from '@/types/insuranceVerification';

type ReverifyPolicyRequest = {
  policyId: string;
  data: AutoReverifyPayload;
};

export const useAutoReverifyInsurancePolicy = (
  options?: MutationOptions<InsuranceVerification, AxiosError, ReverifyPolicyRequest>
) => {
  const externalVerificationRepository = ExternalVerificationRepository();
  const { addMessage } = useContext(AppContext);

  return useMutation({
    mutationFn: async ({ policyId, data }: ReverifyPolicyRequest) =>
      externalVerificationRepository.autoReverifyPolicy({ policyId, data }),
    onSuccess: () => {
      addMessage({
        level: 'success',
        text: 'Policy automatic reverification initiated successfully'
      });
    },
    ...options
  });
};

export default useAutoReverifyInsurancePolicy;
